/** @format */

import { remove } from "lodash";

export function arrayRemoveValue(array, value) {
  return remove(array, function (val) {
    return val !== value;
  });
}
